export default __webpack_public_path__ + "static/lips-atelier-45044a2a2e8ad93290189ae0a739f982.jpg";